import axios from 'axios';

const API_BASE =
    process.env.REACT_APP_API_BASE ||
    (window.location.port === '3000' ? 'http://localhost:3001' : '');

const toDateParam = (date) => (date ? date.toISOString().split('T')[0] : null);

export const fetchUutStatusSummary = async ({
    startDate,
    endDate,
    selectedSerialNumbers,
    selectedFamilies = [],
    ateSwVersion = '',
    selectedTestspec = '',
}) => {
    const response = await axios.get(`${API_BASE}/api/uut-status-summary`, {
        params: {
            startDate: toDateParam(startDate),
            endDate: toDateParam(endDate),
            serialNumbers: selectedSerialNumbers.map((serialNumber) => serialNumber.value).join(','),
            selectedFamilies: selectedFamilies.join(',') || undefined,
            ateSwVersion: ateSwVersion || undefined,
            Testspec: selectedTestspec || undefined,
        },
    });

    return response.data || [];
};

export const fetchSerialNumberOptions = async () => {
    const response = await axios.get(`${API_BASE}/api/serial-numbers`);
    return (response.data || []).map((serialNumber) => ({
        value: serialNumber,
        label: serialNumber,
    }));
};

export const fetchAteSwVersionOptions = async () => {
    const response = await axios.get(`${API_BASE}/api/ate-sw-versions`);
    return (response.data || []).map((item) => ({
        value: item.AteSwVersion,
        label: item.AteSwVersion,
    }));
};

export const fetchTestspecOptions = async () => {
    const response = await axios.get(`${API_BASE}/api/testspecs`);
    return (response.data || []).map((item) => ({
        value: item.Testspec,
        label: item.Testspec,
    }));
};
